<mat-tab-group class="dark-theme tabs" md-no-pagination animationDuration="1000ms">
    <mat-tab label="DEVELOPER">
        <div class="content-box">
            <h1>DEVELOPER. <span><h5>Experienced Software Engineer</h5></span></h1>
            <p>
                I'm a software engineer with over 7 years of professional experience building modern web applications across the full stack.
                <br><br>
                My experience spans frontend and backend development, with a strong focus on Angular-based interfaces and extensive work integrating and designing RESTful APIs. On the backend, I have worked with multiple technology stacks, including Java(Spring Boot), Groovy , Django REST Framework, and Node.js/Express. This breadth has given me a solid understanding of system design, service architecture, and how to build and maintain production-grade applications.
                <br><br>
                I actively leverage AI-assisted development tools such as GitHub Copilot in my daily workflow, alongside modern development environments like VS Code and Cursor. These tools enable efficient iteration, high code quality, and adaptability in rapidly evolving development landscapes.
                <br><br>
                I'm continuously expanding my expertise, with a current focus on cloud technologies and modern deployment workflows. This portfolio itself is deployed on Firebase, reflecting my interest in scalable, streamlined hosting solutions. I'm also quite familiar with Azure Cloud Services as I work with them on a weekly basis.
                <br><br>
                Beyond technical execution, I'm driven by curiosity and continuous improvement. I'm always looking for opportunities to deepen my expertise and take on new challenges. 
                <br>
                You can explore more about this side of me in the Enthusiast section
                or here in my <a routerLink="/portfolio">Portfolio </a>. Where I have currated some of my work and projects. I hope you enjoy viewing them as much as I enjoyed creating them.
            </p>
        </div>
    </mat-tab>
    <mat-tab label="ENTHUSIAST">
        <div class="content-box">
            <h1>ENTHUSIAST.<span><h5>I sometimes do stuff and things</h5></span></h1>
            <p>I'm a serial hobbyist to a fault and love to tinker with new technologies and gadgets.
                I like to challenge myself by learning new skills and by acruing experiences in the real world as well as in the virtual.
                Just to name a few of my more or less active pastimes (Hunting, Flying( Both real and virtual planes ), 3D CAD Design, 3D printing, Embedded systems(Arduino), Gaming, Exercise( Gym, Swimming, Skiing, Running, Biking ), Videography).
                <br>
                <br>
                I'm also a big fan of the maker movement and love to build things with my hands. Check out my <a routerLink="/portfolio">Portfolio</a> to see what I have created!
            </p>
        </div>
    </mat-tab>
    <!-- Entrepreneur tab — restore when needed
    <mat-tab label="ENTREPRENEUR">
        <div class="content-box">
            <h1>ENTREPRENEUR.<span><h5>Well at least aspiring to be one someday...</h5></span></h1>
            <p>
                Working on a few of my own projects that I hope to launch sometime™. 
                Checkout my company page <a href="https://teoriasystems.com" target="_blank" rel="noopener noreferrer">Teoria Systems Oy</a>(Currently company is not active).
            </p>
        </div>
    </mat-tab>
    -->
</mat-tab-group>

